<!-- 预赛 -->
<template>
    <div v-if="winner" class="winner lucky" :block="blockName">
        <k-block :name="blockName" />
        <div class="winner-w-pst-a">
          <h3 class="winner-title">恭喜<span class="winner__user"><k-user :nick="winner.mobile" :logo="winner.logoSrc" /></span>获得</h3>
          <h4 class="winner-intro">【{{type}}-幸运锦鲤奖】-排名<k-txt-rank :value="winner.rank" /></h4>
        </div>        
    </div>
</template>

<script>
    export default {
        name: 'winner-lucky',
        props: ['winner', 'type', 'block'],
        computed: {
            blockName() {
                const {block} = this
                return block ? block : 'winners_lucky'
            }
        }
    }
</script>
